export const defaultOption = {
    default: 'initial',
    options: [
        {
            label: '默认字体',
            value: 'initial',
        },
        {
            label: '苹方',
            value: 'PingFangSC-Regular, 苹方, sans-serif',
        },
        {
            label: '宋体',
            value: 'SimSun, Songti SC, 宋体, serif',
        },
        {
            label: '仿宋',
            value: 'FangSong, STFangSong, 仿宋, serif',
        },
        {
            label: '黑体',
            value: 'SimHei, Heiti SC, 黑体, sans-serif',
        },
        {
            label: '楷体',
            value: 'KaiTi, 楷体, sans-serif',
        },
        {
            label: '微软雅黑',
            value: 'Microsoft YaHei, 微软雅黑, Roboto, sans-serif',
        },
        {
            label: '华文宋体',
            value: 'STSong, 华文宋体, serif',
        },
        {
            label: '华文仿宋',
            value: 'STSong, 华文宋体, serif',
        },
        {
            label: '华文楷体',
            value: 'STKaiti, 华文楷体, serif',
        },
        {
            label: '华文黑体',
            value: 'STHeiti, sans-serif',
        },
        {
            label: '冬青黑体',
            value: 'Hiragino Sans GB, 冬青黑简体中文, sans-serif',
        },
        {
            label: '腾讯体',
            value: 'TencentSans, 腾讯体, sans-serif',
        },
        {
            label: 'Arial',
            value: 'Arial',
        },
        {
            label: 'Helvetica',
            value: 'Helvetica',
        },
        {
            label: 'Times New Roman',
            value: 'Times New Roman',
        },
        {
            label: 'Courier New',
            value: 'Courier New',
        },
        {
            label: 'Calibri',
            value: 'Calibri',
        },
        {
            label: 'Courier Sans MS',
            value: 'Courier Sans MS',
        },
        {
            label: 'Georgia',
            value: 'Georgia',
        },
        {
            label: 'Impact',
            value: 'Impact',
        },
        {
            label: 'Bangla MN',
            value: 'Bangla MN',
        },
        {
            label: 'Baskerville',
            value: 'Baskerville',
        },
        {
            label: 'Chalkboard',
            value: 'Chalkboard',
        },
        {
            label: 'Chalkboard SE',
            value: 'Chalkboard SE',
        },
        {
            label: 'Cochin',
            value: 'Cochin',
        },
    ],
};
//# sourceMappingURL=data.js.map